export default defineNuxtRouteMiddleware(async (to, _from) => {
  // Only apply this middleware to routes that start with /admin
  if (!to.path.startsWith('/admin')) {
    return;
  }

  console.log('`requires-admin` middleware running for path:', to.path);

  const profileStore = useProfileStore();
  const user = useSupabaseUser();

  // If profile isn't loaded yet, fetch it
  if (user.value && (!profileStore.profile || !profileStore.profile.id)) {
    console.log('Profile not loaded, fetching profile data');
    await profileStore.fetchProfile(user.value);
  }

  console.log('Admin check:', profileStore.isAdmin);

  // Check if user is admin
  if (!profileStore.isAdmin) {
    console.log('User attempted to access admin route but is not an admin, redirecting to my account page');
    return navigateTo('/my-account');
  }

  console.log('User is admin, allowing access to admin route');
});